import { render, staticRenderFns } from "./InputTextAndNumber.vue?vue&type=template&id=407f26bc&scoped=true"
import script from "./InputTextAndNumber.vue?vue&type=script&lang=js"
export * from "./InputTextAndNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407f26bc",
  null
  
)

export default component.exports